import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInquiry, IInquiryState } from "./inquiryModel";
import { getAllInquiry } from "./services/inquiry.services";

const initialState: IInquiryState = {
  loading: false,
  error: "",
  InquiryID: null,
  InquiryList: [],
  FilterInquiry: {
    Name: "",
    MobileNo: "",
    Email: "",
  },
};

const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    setInquiryID: (state, action) => {
      state.InquiryID = action.payload;
    },
    clearInquiryID: (state) => {
      state.InquiryID = initialState.InquiryID;
    },
    setFilterInquiry: (state, action) => {
      state.FilterInquiry = action.payload;
    },
    clearFilterInquiry: (state) => {
      state.FilterInquiry = initialState.FilterInquiry;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllInquiry.fulfilled,
      (state, action: PayloadAction<IInquiry[]>) => {
        state.loading = false;
        state.InquiryList = action.payload || [];
      }
    );
    builder.addCase(getAllInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.InquiryList = [];
    });
  },
});

export const {
  clearInquiryID,
  setInquiryID,
  clearFilterInquiry,
  setFilterInquiry,
} = inquirySlice.actions;
export default inquirySlice.reducer;
